export default __webpack_public_path__ + "static/media/loc_img_10.985e0c96.jpg";